import { useMemo, useState } from "react";
import { Session, SessionTypesEnum } from "../../../../../../types/working-model";
import Checkbox from "../../../../../general-ui/checkbox/checkbox";
import Icon, { COLORS, ICONS } from "../../../../../general-ui/icon";

interface IEditAgendaCardProps {
	session: Session;
	toggleDisplay: (s: number) => void;
	onEdit: () => void;
	onDelete: (s: number) => void;
}

const EditAgendaCard: React.FC<IEditAgendaCardProps> = ({ session, toggleDisplay, onEdit, onDelete }) => {

	const [sessionTypeTitle, setSessionTypeTitle] = useState('');

	const sessionTypeIcon = useMemo(() => {
		switch (session.session_type) {
			case SessionTypesEnum.broadcast:
				setSessionTypeTitle('Broadcast');
				return <Icon name={ICONS.VIEWERS_EYE} color={COLORS.WHITE} size={16} />;
			case SessionTypesEnum.onDemand:
				setSessionTypeTitle('On-demand');
				return <Icon name={ICONS.TAB_CHAT} color={COLORS.WHITE} size={16} />;
			/*
				will need these when we add to the SessionTypesEnum
				case 'fireside':
					setSessionTypeTitle('Firesides');
					return <Icon name={ICONS.VIEWERS_EYE} color={COLORS.WHITE} size={16} />;
				case 'meeting':
					setSessionTypeTitle('1:1 Meeting');
					return <Icon name={ICONS.PEOPLE} color={COLORS.WHITE} size={16} />;
				*/
		}
	}, [session.session_type]);

	const languageBubbles = session.languages.slice().splice(0, 3).map((language: string) => <div key={language} className="language-bubble">{language.toUpperCase()}</div>);

	if (session.languages.length > 3) languageBubbles.push(
		<div className="language-bubble">{`+${session.languages.length - 3}`}</div>
	);

	return (
		<div
			className={`edit-session-card ${session.is_on && 'selected'}`}
			onClick={() => toggleDisplay(session.session)}
		>
			<Checkbox
				checked={!!session.is_on}
				value={'can be empty'}
				onChange={() => 'toggle something in the session'}
				color={COLORS.CYAN}
				// backgroundColor={COLORS.WHITE}
				transparent
			/>
			<div className="inner-container">
				{
					session.timestamp &&
					<p className="date">{new Date(session.timestamp).toLocaleDateString(undefined, { month: 'long', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
				}
				<h6>{session.title.base}</h6>
				<div className="lower-container">
					<div className="session-type">{sessionTypeIcon} {sessionTypeTitle}</div>
					<div className="language-list">{languageBubbles}</div>
				</div>
			</div>
			<div className="edit-session-buttons">
				<button onClick={onEdit} className="no-style">
					<Icon name={ICONS.EDIT} color={COLORS.WHITE} size={16} />
				</button>
				<button onClick={() => onDelete(session.session)} className="no-style">
					<Icon name={ICONS.TRASH} color={COLORS.WHITE} size={16} />
				</button>
			</div>
		</div>
	);
};

export default EditAgendaCard;